module.exports = __webpack_public_path__ + "img/l1.45f1fca1.png";